import { AgGridReact } from 'ag-grid-react';
import React, { useEffect, useRef, useState } from 'react'
import { academylist, workerlist } from '../../../services/admin';
import { roleList } from '../../../services/master';
import { studentlist } from '../../../services/student';
import { teacherlist } from '../../../services/teacher';

export const CredentialReport = () => {
    const gridRef = useRef();
    const [role, setRole] = useState(4);
    const [rlist, setRList] = useState([]);

    const [replist, setRepList] = useState([]);
    useEffect(() => {
        roleList().then((res) => {
            if (res.status === true) {
                setRList(res.data);
            }
        });
        listdob(4);
    }, []);

    function listdob(rle) {
        setRepList([]);
        if (rle == 4) {
            studentlist(1).then((res) => {
                if (res.status === true) {
                    setRepList(res.data.details);
                }
            });
        } else if (rle == 5) {
            teacherlist(1).then((res) => {
                if (res.status === true) {
                    if(res.data.details.length > 0){
                        const sdata=res.data.details.map((item)=>{
                            return {
                                ...item,
                                student_name: item.teacher_name
                            }
                        })
                        setRepList(sdata);
                    }
                }
            });
        // } else if (rle == 6) {
        //     const temp = new FormData();
        //     temp.append("status", 1);
        //     workerlist(temp).then((res) => {
        //         if (res.status === true) {
        //             setRepList(res.data.details);
        //         }
        //     });
        }else{
            const temp = new FormData();
            temp.append("status", 1);
            temp.append("role", rle);

             workerlist(temp).then((res) => {
                  if (res.status === true) {
                    if(res.data.details.length > 0){
                        const sdata=res.data.details.map((item)=>{
                            return {
                                ...item,
                                student_name: item.worker_name
                            }
                        })
                        setRepList(sdata);
                    }
                  }
                })
        }


    }

    const columnDefs = [
        {
            headerName: "Name",
            field: "student_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Username",
            field: "username",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

        {
            headerName: "Password",
            field: "password",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Class",
            field: "class_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Section",
            field: "section_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Academy",
            field: "academy_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
    ];

    const exportToCSV = () => {
        gridRef.current.api.exportDataAsCsv({
            fileName: 'Credentials.csv',
            allColumns: true
        });
    };

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">
                    Credential Report
                </h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Reports</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Credential Report
                    </li>
                </ol>
            </div>
            <div className="content-body">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h2 className="main-content-title tx-24 mg-b-5">
                                Credential Report
                            </h2>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-xl-4 col-sm-6">
                                    <label className="form-label">Role</label>
                                    <select
                                        className="default-select form-control wide"
                                        value={role}
                                        onChange={(e) => { setRole(e.target.value); listdob(e.target.value) }}
                                    >
                                        <option value={0} disabled>
                                            Select Role
                                        </option>
                                        {rlist
                                            .filter(item => item.id > 3)
                                            .map((item) => {
                                                return (
                                                    <option value={item.id} key={item.id}>
                                                        {item.name}
                                                    </option>
                                                );
                                            })}

                                    </select>
                                </div>

                                <div className="col-xl-8 col-sm-6">
                                    <div className="res-right mt-5">
                                        <button className="btn btn-success me-2" onClick={exportToCSV}>
                                            Excel Download
                                        </button>

                                    </div>
                                </div>


                            </div>
                            <div className="ag-theme-alpine ag-style mt-2">
                                <AgGridReact
                                    ref={gridRef}
                                    columnDefs={columnDefs}
                                    rowData={replist}
                                    pagination="true"
                                    paginationPageSize="10"
                                    sortingOrder={["asc", "desc"]}
                                    suppressDragLeaveHidesColumns={true}
                                />
                            </div>

                        </div>


                    </div>


                </div>
            </div>
        </div>
    )
}
